module.exports = __webpack_public_path__ + "img/arrow-right.917e7edb.svg";